const SIMPLE_KEY = /^[A-Za-z0-9_.+-]+$/;

export function toSnbt(value: unknown): string {
  if (typeof value === "string") return quote(value);
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (Array.isArray(value)) return `[${value.map(toSnbt).join(",")}]`;
  if (typeof value === "object" && value !== null) {
    const entries = Object.entries(value).map(([k, v]) => `${SIMPLE_KEY.test(k) ? k : quote(k)}:${toSnbt(v)}`);
    return `{${entries.join(",")}}`;
  }
  throw new TypeError(`cannot serialize ${String(value)} to SNBT`);
}

function quote(text: string): string {
  return `"${text.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
